import { render } from "./localization.vue?vue&type=template&id=5f5502b2"
import script from "./localization.vue?vue&type=script&lang=js"
export * from "./localization.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__